import React from 'react';

const BrandSearchFilters = ({ 
  filters, 
  onFilterChange,
  onSearch 
}) => {
  const { keyword, sourceSite } = filters;

  const handleFilterChange = (key, value) => {
    onFilterChange(key, value);
  };

  const handleSearch = () => {
    onSearch();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="bg-gray-50 p-4 rounded-lg mb-4">
      <div className="flex flex-wrap gap-4 items-end">
        {/* 키워드 검색 */}
        <div className="flex-1 min-w-[200px]">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            브랜드명 검색
          </label>
          <input
            type="text"
            value={keyword || ''}
            onChange={(e) => handleFilterChange('keyword', e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="브랜드명(한글)을 입력하세요"
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* 사이트 필터 */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            출처 사이트
          </label>
          <select
            value={sourceSite || ''}
            onChange={(e) => handleFilterChange('sourceSite', e.target.value)}
            className="w-40 px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">전체</option>
            <option value="oliveyoung">올리브영</option>
            <option value="musinsa">무신사</option>
            <option value="weverse">위버스</option>
            <option value="daiso">다이소</option>
            <option value="ktown">케이타운</option>
          </select>
        </div>

        {/* 검색 버튼 */}
        <div>
          <button
            onClick={handleSearch}
            className="h-10 px-4 py-2 bg-slate-600 text-white rounded-md hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors text-sm"
          >
            검색
          </button>
        </div>
      </div>
    </div>
  );
};

export default BrandSearchFilters;

